import { AfterViewInit, Component, EventEmitter, Input, Output, QueryList, ViewChildren, ViewEncapsulation } from '@angular/core';

import { Address } from '../../../core/models/address.model';
import { GroceryCategoryInfo, GroceryCategoryItem } from '../../../core/models/grocery-category-info.model';
import { GroceryVendorDetails } from '../../../core/models/grocery-vendor-details.model';

import { GroceryCategoryItemsHorizontalListComponent } from '../grocery-category-items-horizontal-list/grocery-category-items-horizontal-list.component';

@Component({
  selector: 'app-vendor-grocery-categories',
  templateUrl: './vendor-grocery-categories.component.html',
  styleUrls: ['./vendor-grocery-categories.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class VendorGroceryCategoriesComponent implements AfterViewInit {
  @Input()
  public serviceType: number;

  @Input()
  public address: Address;

  @Input()
  public vendorDetails: GroceryVendorDetails;

  @Input()
  public categories: Array<GroceryCategoryItem>;

  @Input()
  public parentCategoryInfo?: GroceryCategoryInfo;

  @Output()
  public groceryCategoriesRendered = new EventEmitter<
    Array<{ categoryId: number; scrollElement: HTMLElement; nativeElement: HTMLElement }>
  >();

  @ViewChildren('groceryItemsCategories')
  public groceryItemsCategoriesComponents: QueryList<GroceryCategoryItemsHorizontalListComponent>;

  ngAfterViewInit() {
    if (this.groceryItemsCategoriesComponents?.length) {
      const groceryItemsCategories: Array<{ categoryId: number; scrollElement: HTMLElement; nativeElement: HTMLElement }> = [];

      this.groceryItemsCategoriesComponents.toArray().forEach((groceryItemCategoryComponent) => {
        groceryItemsCategories.push({
          categoryId: groceryItemCategoryComponent.getCategoryId(),
          scrollElement: groceryItemCategoryComponent.getScrollElement(),
          nativeElement: groceryItemCategoryComponent.getNativeElement(),
        });
      });

      this.groceryCategoriesRendered.next(groceryItemsCategories);
    }
  }
}
